import VueCookies from 'vue-cookies'
// setToken
export const setCookies = (key, val, cookieExpires) => {
    VueCookies.set(key, val, { expires: cookieExpires || 1 })
}
// 获取getCookies
export const getCookies = (key) => {
    return VueCookies.get(key)
}
// 获取removeCookies
export const removeCookies = (key) => {
    return VueCookies.remove(key)
}

// 存储localStorage
export const setStorages = (key, val) => {
    if (typeof val === 'object' && val !== null) {
        localStorage.setItem(key, JSON.stringify(val));
    } else {
        localStorage.setItem(key, val);
    }
}

// 获取localStorage
export const getStorages = (key) => {
    const val = localStorage.getItem(key);
    try {
        return JSON.parse(val);
    } catch {
        return val;
    }
}

// 清除localStorage
export const removeStorages = (key) => {
    localStorage.removeItem(key);
}

